<template>
  <div>
    <el-dialog
      :visible.sync="ifShow"
      :title="title"
      width="900px"
      @close="$emit('closeDialog', false)"
    >
      <el-form
        ref="goodsForm"
        :model="addPopData"
        :rules="rules"
        label-position="right"
        label-width="7rem"
      >
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="公司名称" prop="companyName" required>
              <el-select v-model="addPopData.companyName" filterable placeholder="请选择" @change="companySelection(addPopData.companyName)">
                <el-option v-for="(item , index) in addPopSelectData" :key="index" :label="item.companyName" :value="item.companyName" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公司地址">
              <el-input v-model="addPopData.companyAddress" v-input-filter disabled maxlength="15" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="联系人" prop="relationName" required>
              <el-input v-model="addPopData.relationName" maxlength="15" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" prop="relationSex">
              <el-radio-group v-model="addPopData.relationSex">
                <el-radio label="男" value="1" />
                <el-radio label="女" value="2" />
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="联系电话" prop="relationPhone" required>
              <el-input v-model="addPopData.relationPhone" maxlength="11" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="固定电话" prop="fixTelphone">
              <el-input v-model="addPopData.fixTelphone" v-input-filter />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="备注" class="add-remarks" prop="remarks">
              <el-input v-model="addPopData.remarks" type="textarea" />
              <span v-if="addPopData.remarks">还可以输入{{ titleMaxLength - addPopData.remarks.length }}个字</span>

            </el-form-item>
          </el-col>
        </el-row>
        <div class="add-pop-btn" @click="addSubmission('goodsForm')">
          提交
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import * as get from '@/api/personal/customer/contacts/index.js' // 请求接口
import inputFilter from '@/directives/validation/index.js'
export default {
  directives: {
    inputFilter
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '联系人-新增'
    },
    popData: {
      type: [Object, String],
      default: ''
    },
    detailsData: { },
    status: {
      type: String,
      default: ''
    }
  },
  data() {
    const checkPhone = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('联系电话不可为空'))
      } else {
        const data = this.personDetails
        const aaa = data.some(item => {
          return this.addPopData.relationPhone === item.relationPhone
        })
        if (aaa) {
          callback(new Error('联系电话已经存在'))
        } else {
          callback()
        }
      }
    }
    return {
      ifShow: this.dialogShow,
      // 正则
      rules: {
        companyName: [{ required: true, message: '必填' }],
        data: [{ required: true, message: '必填' }],
        companyAddress: [{ required: true, message: '必填' }],
        // 联系人
        relationName: [
          { required: true, message: '必填' },
          { validator: this.$validate('names') }
        ],
        relationSex: [{ required: true, message: '必填' }],
        // 手机号
        relationPhone: [
          { required: true, message: '必填' },
          { validator: this.$validate('phone') }
          // { trigger: 'blur', validator: checkPhone }

        ],
        // 固话
        fixTelphone: [
          { pattern: /^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$/, message: '请输入正确固话' }
        ],
        // 时间
        createDate: [{ required: true, message: '必填' }],
        relationRecord: [{ required: true, message: '必填' }] // 备注
      },
      // 新增数据
      // companyName: '', // 公司名称
      // companyAddress: '', // 公司地址
      // relationName: '', // 联系人
      // relationSex: '男', // 性别
      // relationPhone: '', // 联系电话
      // fixTelphone: '', // 固定电话
      // remarks: '', // 备注
      // relationId: '', // Id
      // data: []
      addPopData: this.popData,
      personDetails: this.detailsData,
      // 新增公司下拉数据
      addPopSelectData: {
        companyName: '',
        companyAddress: ''
      },
      // 新增公司下拉-地址联动
      addPopCompanyData: '',
      // 保存和编辑 备注内容、字数
      titleMaxLength: 255
    }
  },
  watch: {
    'addPopData.remarks'() {
      if (this.addPopData.remarks.length > this.titleMaxLength) {
        this.addPopData.remarks = String(this.addPopData.remarks).slice(0, this.titleMaxLength)
      }
    }
  },
  created() {
    get.customerListEcho().then(res => {
      this.addPopSelectData = res.result
    }).catch(error => {
      console.log(error)
    })
  },
  methods: {
    // 新增-提交按钮
    addSubmission(formName) {
      // 正则匹配
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.status == 'create') {
            const sendData = {}
            sendData.companyName = this.addPopData.companyName
            sendData.companyAddress = this.addPopData.companyAddress
            sendData.relationName = this.addPopData.relationName
            sendData.relationSex = this.addPopData.relationSex
            sendData.relationPhone = this.addPopData.relationPhone
            sendData.fixTelphone = this.addPopData.fixTelphone
            sendData.remarks = this.addPopData.remarks
            sendData.relationId = this.addPopData.relationId
            get.AddList(sendData).then(res => {
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.$emit('EchoClick', false)
              this.$emit('closeDialog', false)
            }).catch(error => {
              console.log(error)
            })
            this.$refs[formName].resetFields()
          } else {
            const editData = {}
            editData.companyName = this.addPopData.companyName
            editData.companyAddress = this.addPopData.companyAddress
            editData.relationName = this.addPopData.relationName
            editData.relationSex = this.addPopData.relationSex
            editData.relationPhone = this.addPopData.relationPhone
            editData.fixTelphone = this.addPopData.fixTelphone
            editData.remarks = this.addPopData.remarks
            editData.id = this.addPopData.id
            get.editContactsList(editData).then(res => {
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.$emit('EchoClick', false)
              this.$emit('closeDialog', false)
            }).catch(error => {
              console.log(error)
            })
          }
        } else {
          return false
        }
      })
    },
    // 新增-公司选中回调
    companySelection(data) {
      console.log(this.addPopSelectData)
      console.log(data)
      for (const con in this.addPopSelectData) {
        if (this.addPopSelectData[con].companyName == data) {
          this.addPopData.companyAddress = this.addPopSelectData[con].companyAddress
          this.addPopData.relationId = this.addPopSelectData[con].id
          this.addPopData.companyName = this.addPopSelectData[con].companyName
          // this.addPopData.relationName = this.addPopData.data[con].customerName
        }
      }
    }
  }
}
</script>

<style scoped lang='scss'>
  /*新增弹窗*/
  .add-pop-btn{
    width:100px;
    height:40px;
    line-height: 40px;
    text-align: center;
    margin: 0 auto;
    background:rgba(190,35,22,1);
    border-radius:4px;
    color: #FFFFFF;
    font-size: 18px;
    cursor: pointer;
  }
  .el-select, .el-cascader {
    width: 100% !important;
  }
  /deep/ .el-date-editor.el-input {
    width: 100% !important;
  }
</style>
